module.exports = __webpack_public_path__ + "img/ai_logo.9c2d0897.svg";